/*
 * Eiis Components Library
 * Copyright 2018-2020 Eldur og Is Software
 */

import EiisStore from './lib/Store.js'

import EiisLogger from './lib/Logger.js'
import EiisLanguage from './lib/Language.js'
import * as constants from './lib/Constants.js'

import './main.css'

//import { version } from '../package.json';
const version = "1.2.7";

import * as components from './components/index.js'

var Eiis = Object.freeze({
	name: "Eiis",
	version: version,
	logger: new EiisLogger(),
	language: new EiisLanguage(),
	constants: constants,
	Store: EiisStore,
	components: components,
	helpers: {
		round: function (x) {
			return (x / 100) * 100;
		},

		setCookie: function (name, value) {
			document.cookie = name + '=' + value + ';path=/;';
		},

		removeCookie: function (name) {
			document.cookie = name + '=;' + 'expires=Thu, 01-Jan-70 00:00:01 GMT;';
		},

		formatDate: function (d) {
			let date = new Date(d);
			return date.toDateString();
		},

		camelCase: function (s) {
			let camelCased = s.replace(/-([a-z])/g, function (g) { return g[1].toUpperCase(); });
			return camelCased;
		},

		snakeCase: function (s) {
			let snakeCased = s.replace(/([a-z][A-Z])/g, function (g) { return g[0] + '_' + g[1].toLowerCase() });
			return snakeCased;
		},

		hyphenCase: function (s) {
			let hypenCased = s.replace(/([a-z][A-Z])/g, function (g) { return g[0] + '-' + g[1].toLowerCase() });
			return hypenCased;
		},

		bootstrap: function (app) {
			app.component("eiis-button", components.Button);
			app.component("eiis-card", components.Card);
			app.component("eiis-footer", components.Footer);
			app.component("eiis-form", components.Form);
			app.component("eiis-header", components.Header);
			app.component("eiis-icon", components.Icon);
			app.component("eiis-image", components.Image);
			app.component("eiis-menu", components.Menu);
			app.component("eiis-navbar", components.Navbar);
			app.component("eiis-page", components.Page);
			app.component("eiis-panel", components.Panel);
			app.component("eiis-router", components.Router);
			return app;
		}
	}
})

export default Eiis;

export function install(app) {
	if (install.installed)
		return;
	install.installed = true;
	app.component("Eiis", Eiis);
	//components.forEach(component => {
	//	app.component(component.name, component)
	//})
}

// create module definition for Vue.use()
const plugin = {
	install
}
let globalVue = null;
if (typeof window !== 'undefined') {
	globalVue = window.Vue;
} else if (typeof global !== 'undefined') {
	//globalVue = global.Vue;
}
if (globalVue) {
	console.log('exporting library', Eiis);
	globalVue.use(plugin);
}

export { Button } from './components/index.js'
export { Icon } from './components/index.js'
export { Image } from './components/index.js'
export { Navbar } from './components/index.js'
export { Menu } from './components/index.js'
export { Page } from './components/index.js'
export { Header } from './components/index.js'
export { Footer } from './components/index.js'
export { Card } from './components/index.js'
export { Panel } from './components/index.js'
export { Form } from './components/index.js'

export { default as Store } from './lib/Store.js'
